export default __webpack_public_path__ + "static/media/Glycan-Structure-Dictionary-img.1d3d2303.svg";